import React from "react";

import { Tab } from "clearsense-ui/components";

const Tabs = ({ currentTab, previewTables, setCurrentTab }) => (
  <Tab className="border-b uppercase px-4" style="secondary">
    <Tab.Item
      active={currentTab === "results"}
      className="flex-none"
      onClick={() => setCurrentTab("results")}
    >
      RESULTS
    </Tab.Item>
    <Tab.Item
      active={currentTab === "sqlHistory"}
      className="flex-none"
      onClick={() => setCurrentTab("sqlHistory")}
      data-cy="sql-editor-query-history-tab"
    >
      QUERY HISTORY
    </Tab.Item>
    {Object.keys(previewTables).map((column, idx) => (
      <Tab.Item
        key={idx}
        className="flex-none"
        active={currentTab === column}
        onClick={() => setCurrentTab(column)}
      >
        {`PREVIEW: \`${column}\``}
      </Tab.Item>
    ))}
  </Tab>
);

export default Tabs;
